import realpressHeaderMap from './shortcode/header-map/header-map';
import realpressSwitchLayout from './shortcode/header-map/switch-layout';

document.addEventListener( 'DOMContentLoaded', ( event ) => {
	realpressHeaderMap();
	realpressSwitchLayout();
} );
